import M_URL from '~url@1.0'
import M_URL_HANDLE from '~url_handler@1.0'
import M_REQUEST from '~request@1.0'

const G_REQUEST = new M_REQUEST({ gatewayType: 'platform' })

const G_QUERY = M_URL.getUrlParam()

export default {
	data () {
		return {
            licenseId: '',
            isLicensePage: false,
			isShowErr: false,
			title: '', // 标题
			pdfUrl: '', // PDF链接
            licenseMap: {},
            logoImg: M_URL_HANDLE.addUrlProtocol('//cimg1.fenqile.com/ibanner2/M00/02/82/kagHAF66FL-AZ4CQAAANaWNNCNc898.png')
		}
	},

    computed: {
        /**
         * 证件详情
         * @returns {String}
         */
        licenseImgList () {
            return this.licenseMap[this.licenseId]
        }
    },
	methods: {
		// 逻辑入口
		init () {
			
			// 查询规则详情
			this.title = G_QUERY.title

            // pdf协议
			this.pdfUrl = G_QUERY.url
			this.isShowErr = !M_URL.isUrl(this.pdfUrl)

            // 执照详情
            this.isLicensePage = !!G_QUERY.is_license // TODO：下个版本去掉这个，可以根据license_id判断
            this.licenseId = G_QUERY.license_id

            if (this.isLicensePage) {
                this.queryPageConfig()
            } else if (this.isShowErr) { // pdf页面，协议链接格式不正确toast提示
				this.$message.error('PDF地址不正确')
			} else if (!this.pdfUrl && !this.licenseId) {
                this.$message.error('非法链接')
            }
			
			if (this.title) {
				window.document && window.document.title ? window.document.title += ' - ' + this.title : ''
			}
		},

        /**
		 * 查询页面配置
		 */
		queryPageConfig () {
			return G_REQUEST.ajax({
				url: '/route0014/platform/acc/querySceneMsg.json',
				data: {
					scene: 'fqlIndex',
				}
			}).then(res => {

				if (+res.retcode === 0) {
					let ret = res && res.result_rows || {}
                    this.licenseMap = ret.licenseMap || {}
				}

			}).catch(err =>{
				this.$message.error(err);
			})
	
		},
	},
    created () {
        this.init()
    }
}
